<div class="login-container">
   <div class="w-50 d-lg-block d-none">
     <app-left-ui-template
     [welcomeText]="emailSent() ? 'Account Verification' : 'Reset Your Password'"
     [welcomeSubtitle]="emailSent()
            ? 'Help us create a trusted community where every connection counts-verify your account to get started'
            : 'We\'ll guide you through a quick reset so you can continue discovering meaningful connections'"
   ></app-left-ui-template>
  </div>
  <div class="login-form">
    @if (emailSent()) {
      <app-verify-code [email]="forgotModel.usernameOrEmail"></app-verify-code>
    } @else {
      <div class="">
        <div class="form-container">
          <div class="logo-container">
            <img src="assets/images/key.svg" />
          </div>
          <div class="form-header">
            <h2 class="form-title">Forgot Password?</h2>
            <p class="form-subtitle">
              Don't worry, it happens to the best of us.
            </p>
          </div>

          <!-- Error message -->
          <div *ngIf="errorMessage()" class="alert alert-danger" role="alert">
            <p>
              <i class="bi bi-exclamation-triangle me-2"></i>
              {{ errorMessage() }}
            </p>
            <button
              type="button"
              class="btn-close"
              (click)="clearError()"></button>
          </div>

          <!-- Form starts -->
          <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
            <div class="form-group">
              <label for="usernameOrEmail">
                <i class="fa-solid fa-envelope me-2"></i> Email / Username
              </label>
              <input
                type="text"
                id="usernameOrEmail"
                name="usernameOrEmail"
                placeholder="Enter your email or username"
                class="form-control"
                [(ngModel)]="forgotModel.usernameOrEmail"
                required
                [disabled]="isLoading()"
                #usernameOrEmail="ngModel" />
              <div
                *ngIf="
                  usernameOrEmail.invalid &&
                  (usernameOrEmail.dirty || usernameOrEmail.touched)
                "
                class="error-message">
                <small *ngIf="usernameOrEmail.errors?.['required']"
                  >Email or username is required.</small
                >
              </div>
            </div>

            <div class="info-note">
              <i class="bi bi-info-circle me-2"></i>
              We'll send you a link to reset your password. Check your email
              inbox and spam folder.
            </div>

            <button
              type="submit"
              class="login-btn primary-gradient"
              [disabled]="loginForm.invalid || isLoading()">
              <span *ngIf="!isLoading()">Send Reset Link</span>
              <span *ngIf="isLoading()">
                <i class="bi bi-arrow-repeat spin me-2"></i>Sending...
              </span>
            </button>
          </form>

          <div class="divider">
            <span>or</span>
          </div>
          <div class="signup-link">
            Remember your password?
            <button
              type="button"
              class="register-link"
              (click)="navigateToLogin()"
              [disabled]="isLoading()">
              Back to Sign In
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
